export default __webpack_public_path__ + "static/media/macoRusticoComfortsluiting.jpg";